export default __webpack_public_path__ + "images/065db74e141b4dbdbac841ca0231ee66-buildBuzz_CA.webp";